//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    colOptions: {
      default: null,
    },
    role: {
      default: "Couple",
    },
  },
  watch: {
    role() {
      this.$forceUpdate()
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("changeHeader", value);
    },
  },
};
